<template>
  <md-toolbar>
    <slot name="actions" actionStyle="margin-right: 15px"></slot>
  </md-toolbar>
</template>
<script>
export default {};
</script>
